(function() {
    class FloatingMenu extends HTMLElement {
        constructor() {
            super(), this.state = {
                activePanel: null
            }, this.lastActive = null, "requestIdleCallback" in window ? window.requestIdleCallback(() => {
                this.attachEventListeners(), this.setupResizeObserver()
            }) : setTimeout(() => {
                this.attachEventListeners(), this.setupResizeObserver()
            }, 1)
        }
        connectedCallback() {
            if (document.body.classList.add("has-floating-menu"), !this.querySelector(".nav-indicator")) {
                const indicator = document.createElement("span");
                indicator.className = "nav-indicator", indicator.style.cssText = "position:absolute;bottom:0;height:2px;width:0;transition:transform .25s,width .25s,opacity .25s;background:currentColor;opacity:0;", this.appendChild(indicator)
            }
            const nav = document.querySelector(".floating-nav");
            nav && (document.documentElement.style.setProperty("--floating-menu-height", nav.offsetHeight + "px"), document.documentElement.style.paddingBottom = "var(--floating-menu-height)"), this.setInitialActiveNav()
        }
        attachEventListeners() {
            this.addEventListener("click", this.handleClick.bind(this)), document.addEventListener("keydown", this.handleKeyDown.bind(this)), document.body.addEventListener("click", event => {
                if (!event.target.closest(".kymee-drawer__close")) return;
                const cartDrawer = document.querySelector(".kymee-drawer");
                cartDrawer && cartDrawer.classList.remove("is-open"), document.body.style.overflow = "", document.body.classList.remove("overflow-hidden", "overflow-hidden-tablet"), this.state.activePanel = null, this.restoreAfterDrawer(), this.setInitialActiveNav()
            }), document.body.addEventListener("click", event => {
                event.target.closest(".category-drawer .drawer-close") && (document.body.style.overflow = "", document.body.classList.remove("overflow-hidden", "overflow-hidden-tablet"), this.state.activePanel = null, this.restoreAfterDrawer(), this.setInitialActiveNav())
            }), this.updateCartCount(), this.cartInterval = setInterval(this.updateCartCount.bind(this), 1e4)
        }
        disconnectedCallback() {
            clearInterval(this.cartInterval)
        }
        setupResizeObserver() {
            "ResizeObserver" in window && new ResizeObserver(() => {
                this.state.activePanel && this.positionPanel()
            }).observe(document.body)
        }
        getPageState() {
            const path = window.location.pathname;
            return {
                isHome: path === "/" || path === "/index"
            }
        }
        handleClick(event) {
            const target = event.target.closest("[data-nav], [data-action]");
            if (!target) return;
            const panel = target.dataset.nav,
                action = target.dataset.action,
                indicator = this.querySelector(".nav-indicator"),
                home = this.querySelector('.nav-item[data-nav="home"]');
            if (panel === "home" && this.getPageState().isHome) {
                event.preventDefault(), this.closePanel(), this.restoreTo(home);
                return
            }
            if (action === "close") {
                this.closePanel();
                return
            }
            if (panel === "cart") {
                event.preventDefault(), this.closePanel();
                const cartDrawer = document.querySelector(".drawer");
                cartDrawer && (cartDrawer.classList.add("active"), document.body.classList.add("overflow-hidden")), this.updateActiveState(target);
                return
            }
            if (panel === "search") {
                event.preventDefault(), this.closePanel();
                const searchDrawer = document.querySelector(".header__search details");
                searchDrawer && (searchDrawer.setAttribute("open", "true"), document.body.classList.add("overflow-hidden"), requestAnimationFrame(() => {
                    const searchInput = searchDrawer.querySelector(".search__input.field__input");
                    searchInput && (searchInput.focus(), searchInput.click())
                }));
                return
            }
            this.updateActiveState(target)
        }
        handleKeyDown(event) {
            event.key === "Escape" && this.closePanel()
        }
        togglePanel(panel) {
            this.state.activePanel === panel ? this.closePanel() : this.openPanel(panel)
        }
        openPanel(panel) {
            this.closePanel(), this.state.activePanel = panel;
            const el = document.getElementById(`${panel.charAt(0).toUpperCase()+panel.slice(1)}Drawer`);
            el && (el.classList.add("active"), el.removeAttribute("aria-hidden"), document.body.style.overflow = "hidden")
        }
        closePanel() {
            if (!this.state.activePanel) return;
            const panel = this.state.activePanel,
                el = document.getElementById(`${panel.charAt(0).toUpperCase()+panel.slice(1)}Drawer`);
            el && (el.classList.remove("active"), el.setAttribute("aria-hidden", "true")), this.restoreAfterDrawer(), this.state.activePanel = null, document.body.style.overflow = "", document.body.classList.remove("overflow-hidden", "overflow-hidden-tablet")
        }
        restoreAfterDrawer() {
            const indicator = this.querySelector(".nav-indicator"),
                {
                    isHome
                } = this.getPageState();
            if (this.clearActive(), isHome) {
                const h = this.querySelector('.nav-item[data-nav="home"]');
                h.classList.add("active"), this.moveIndicator(h, indicator), indicator.style.opacity = "1"
            } else indicator.style.opacity = "0"
        }
        clearActive() {
            this.querySelectorAll(".nav-item[data-nav]").forEach(i => i.classList.remove("active"))
        }
        restoreTo(item) {
            const indicator = this.querySelector(".nav-indicator");
            this.clearActive(), item.classList.add("active"), indicator.style.opacity = "1", this.moveIndicator(item, indicator)
        }
        setInitialActiveNav() {
            const indicator = this.querySelector(".nav-indicator"),
                home = this.querySelector('.nav-item[data-nav="home"]'),
                {
                    isHome
                } = this.getPageState();
            indicator.style.opacity = "0", setTimeout(() => {
                isHome && (home.classList.add("active"), indicator.style.opacity = "1", this.moveIndicator(home, indicator))
            }, 80)
        }
        updateActiveState(clickedItem) {
            const indicator = this.querySelector(".nav-indicator");
            this.clearActive(), clickedItem.classList.add("active"), indicator.style.opacity = "1", this.moveIndicator(clickedItem, indicator)
        }
        moveIndicator(item, indicator) {
            const navRect = this.querySelector(".floating-nav").getBoundingClientRect(),
                itemRect = item.getBoundingClientRect(),
                offset = itemRect.left - navRect.left + itemRect.width / 2 - indicator.offsetWidth / 2;
            indicator.style.transform = `translateX(${offset}px)`
        }
        positionPanel() {
            if (!this.state.activePanel) return;
            const el = document.getElementById(`${this.state.activePanel.charAt(0).toUpperCase()+this.state.activePanel.slice(1)}Drawer`);
            el && el.offsetHeight
        }
        updateCartCount() {
            fetch("/cart.js").then(r => r.json()).then(cart => {
                const count = cart.item_count;
                document.querySelectorAll("[data-cart-count]").forEach(el => {
                    el.textContent = count, el.classList.toggle("show", count > 0)
                })
            }).catch(() => {})
        }
    }
    customElements.get("floating-menu") || customElements.define("floating-menu", FloatingMenu)
})();
//# sourceMappingURL=/cdn/shop/t/112/assets/floating_menus.js.map?v=66068299377538886161768196312